export function getSpeedUnit(speedUnitEnum) {
    switch(speedUnitEnum) {
        case 1: return 'mph';
        case 2: return 'kph';
        case 3: return 'knots';
        case 4: return 'mps';
        default: '';
    }
}

export function getDistanceUnit(distantUnitEnum) {
    switch(distantUnitEnum) {
        case 1: return 'miles';
        case 2: return 'kilometers';
        default: '';
    }
}

export function getPressureUnit(pressureUnitEnum) {
    switch(pressureUnitEnum) {
        case 1: return 'inHg';
        case 2: return 'mb';
        default: '';
    }
}

export function getWindDirection(windDirectionDegrees) {
    if (typeof windDirectionDegrees !== 'number') {
        return null;
    }
    // Insure direction is between 0 and 360
    while (0 > windDirectionDegrees)
        windDirectionDegrees += 360;
    while (359 < windDirectionDegrees)
        windDirectionDegrees -= 360;
    windDirectionDegrees /= 22.5;

    switch (Math.round(windDirectionDegrees, 0))
    {
        case 1:
            return 'NNE';
        case 2:
            return 'NE';
        case 3:
            return 'ENE';
        case 4:
            return 'E';
        case 5:
            return 'ESE';
        case 6:
            return 'SE';
        case 7:
            return 'SSE';
        case 8:
            return 'S';
        case 9:
            return 'SSW';
        case 10:
            return 'SW';
        case 11:
            return 'WSW';
        case 12:
            return 'W';
        case 13:
            return 'WNW';
        case 14:
            return 'NW';
        case 15:
            return 'NNW';
        default:  // 0, 16
            return 'N';
    }
}
